export const CREATE_INVOICE = gql`
  mutation CreateInvoiceV1($input: CreateInvoiceInput!) {
    createInvoice(input: $input) {
      id
    }
  }
`
